<div *ngIf="isLoading" class="overlay"></div>
<div *ngIf="isLoading" class="loader"></div>
<div class="example-inner">
  <div class="container">
    <div class="header">
      <button mat-raised-button 
            color="primary" 
            class="dashboard-button" 
            routerLink="/suppliers">
      <mat-icon>dashboard</mat-icon>
      <span>Suppliers Dashboard</span>
      </button>
      <h1 class="page-title" > List Suppliers</h1>
  </div>
  <span><h1>Suppliers</h1></span>
  <kendo-grid
    [data]="gridData | async"
    [height]="650"
    [pageSize]="gridState.take"
    [skip]="gridState.skip"
    [sort]="gridState.sort"
    [sortable]="true"
    [pageable]="true"
    scrollable="none"
    [filterable]="true"
    [filter]="gridState.filter"
    (dataStateChange)="dataStateChange($event)"
    (edit)="updateRepair($event)"
    (add)="createRepair()"
  >
    <ng-template kendoGridToolbarTemplate>
      <button kendoGridAddCommand>Add new</button>
    </ng-template>
    <kendo-grid-column field="title" title="Title"></kendo-grid-column>
    <kendo-grid-column field="supplierWebsite" title="Website"></kendo-grid-column>
    <kendo-grid-column field="supplierPhone" title="Phone"></kendo-grid-column>
    <kendo-grid-command-column title="Actions" [width]="220">
      <ng-template kendoGridCellTemplate>
        <button kendoGridEditCommand [primary]="true">Edit</button>
        <button kendoGridRemoveCommand>Delete</button>
      </ng-template>
    </kendo-grid-command-column>
  </kendo-grid>
</div>
</div>
